var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 18C4.75 17.5858 4.41421 17.25 4 17.25C3.58579 17.25 3.25 17.5858 3.25 18V21C3.25 21.9665 4.0335 22.75 5 22.75H19C19.9665 22.75 20.75 21.9665 20.75 21V18C20.75 17.5858 20.4142 17.25 20 17.25C19.5858 17.25 19.25 17.5858 19.25 18V21C19.25 21.1381 19.1381 21.25 19 21.25H5C4.86193 21.25 4.75 21.1381 4.75 21V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C12.1989 17.75 12.3897 17.671 12.5303 17.5303L18.0606 12C18.2751 11.7855 18.3393 11.4629 18.2232 11.1827C18.1071 10.9024 17.8337 10.7197 17.5303 10.7197H12.75V2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V10.7197H6.46966C6.16631 10.7197 5.89283 10.9024 5.77675 11.1827C5.66066 11.4629 5.72483 11.7855 5.93933 12L11.4697 17.5303C11.6103 17.671 11.8011 17.75 12 17.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAlt);
export default __webpack_public_path__ + "static/media/download-alt.669bcea7e6fcb9ef6cbfa83d55aabbff.svg";
export { ForwardRef as ReactComponent };